import { DataTableColumnCell } from '@/components/ui/data-table/DataTableColumnCell'

// TODO: this file and rank badge as same component, need to refactor
// Array of color style objects
export const colorStyles = [
  { bg: 'bg-blue-50', text: 'text-blue-600', border: 'border-blue-100' },
  { bg: 'bg-green-50', text: 'text-green-700', border: 'border-green-100' },
  { bg: 'bg-red-50', text: 'text-red-600', border: 'border-red-100' },
  { bg: 'bg-gray-50', text: 'text-gray-700', border: 'border-gray-100' },
  { bg: 'bg-yellow-50', text: 'text-yellow-700', border: 'border-yellow-100' },
  { bg: 'bg-lime-50', text: 'text-green-900', border: 'border-lime-100' },
]

// Predefined color styles with semantic names
export const semanticStyles = {
  success: {
    bg: 'bg-green-50',
    text: 'text-green-700',
    border: 'border-green-100',
  },
  error: { bg: 'bg-red-50', text: 'text-red-600', border: 'border-red-100' },
  warning: {
    bg: 'bg-yellow-50',
    text: 'text-yellow-700',
    border: 'border-yellow-100',
  },
  info: { bg: 'bg-blue-50', text: 'text-blue-600', border: 'border-blue-100' },
  neutral: {
    bg: 'bg-gray-50',
    text: 'text-gray-700',
    border: 'border-gray-100',
  },
}

// Hash function to map string to a color index
function hashStringToIndex(str: string, max: number) {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  return Math.abs(hash) % max
}

type ColorStyle = {
  bg: string
  text: string
  border: string
}

interface ScalrBadgeProps {
  row?: any
  accessorKey?: string
  className?: string
  common?: boolean
  customStyle?: ColorStyle
  conditionalStyle?: (value: any) => ColorStyle
  children?: React.ReactNode
}

// Props: same as DataTableColumnCell with additional options
export function ScalrBadge({
  row,
  accessorKey,
  className = '',
  common = false,
  customStyle,
  conditionalStyle,
  children,
  ...props
}: ScalrBadgeProps) {
  const value = row && accessorKey ? row.getValue(accessorKey) : children

  // Determine which style to use (priority: conditionalStyle > customStyle > hash-based)
  let style: ColorStyle
  if (conditionalStyle) {
    style = conditionalStyle(value)
  } else if (customStyle) {
    style = customStyle
  } else {
    const idx = hashStringToIndex(String(value), colorStyles.length)
    style = colorStyles[idx]
  }

  const badgeClassName = `inline-block p-2 rounded-md text-sm border ${style.bg} ${style.text} ${style.border}${className ? ' ' + className : ''}`

  return (
    <>
      {common ? (
        <div className={badgeClassName}>{value}</div>
      ) : (
        <DataTableColumnCell
          {...props}
          row={row}
          accessorKey={accessorKey || ''}
          className={badgeClassName}
        >
          {value}
        </DataTableColumnCell>
      )}
    </>
  )
}

export default ScalrBadge
